import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20soft%20abstract%20flowing%20curves%20in%20amber%20and%20cream%20tones%2C%20minimalist%20style%2C%20elegant%20and%20inspirational%20composition%2C%20subtle%20gradient%20with%20gentle%20light%20rays%2C%20no%20text%20no%20people&width=1920&height=700&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-60"
        />
      </div>
      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-5 leading-tight">
          准备好让你的
          <span className="text-primary-600">故事</span>
          被世界看见了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10 max-w-xl mx-auto leading-relaxed">
          加入人人出彩，与58万+创作者一起，分享你的才华与故事。每一个普通的你，都值得拥有属于自己的高光时刻。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all hover:scale-105 cursor-pointer"
          >
            立即加入人人出彩
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/all"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-background-200 text-foreground-700 font-medium text-sm md:text-base hover:bg-background-300 transition-all cursor-pointer"
          >
            浏览更多故事
          </Link>
        </div>
      </div>
    </section>
  );
}